import React, { Component} from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import PDFViewer from '../containers/Onboarding/PDFViewer';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';

const styles = theme => ({
    container: {
        width: '100%',
        // display: 'flex',
        // flexWrap: 'wrap',
        display: 'table-cell',
        textAlign: 'center',
        verticalAlign: 'middle',
    },
    root: {
        marginLeft: theme.spacing.unit,
        marginBottom: '6px',
        width: '100%',
    },
    textField: {
        marginLeft: theme.spacing.unit,
        marginRight: theme.spacing.unit,
        width: '300px',
      },
      button: {
        //margin: theme.spacing.unit,
      },
    card: {
        minWidth: 250,
        width: 400,
        height: 200,
        marginRight: 6,
        marginBottom: 6,
    
    },
    table: {
        width: '100%',
    },
    link: {
        textDecoration: 'none',
      },
    header:{
            fontSize: 13,
    },
    row:{
        fontSize: 12
    },
});

class UploadedDoc extends Component  {
    constructor(props) {
        super(props);
    }
    state = {
        file: null,
        doc_name: null,
        open:false,
        fileUrl: ''
    }

    handleClickOpen = (fileUrl) => {
        this.setState({ open: true, fileUrl: fileUrl });
    };

    handleClose = (value) => {
        this.setState({ open: false, fileUrl: '' });
    };

    uploadFile = (event) => {

    }
    
    handleReset = (event, filename) => {
        
    }
    
    handleChange = prop => event => {
        this.setState({ [prop]: event.target.value });
    };

    render(){
        /*let rows = [
            {doc_name: 'doc1', filename: 'doc1.jpeg'},
            {doc_name: 'doc2', filename: 'doc2.jpeg'},
            {doc_name: 'doc3', filename: 'doc3.jpeg'},
          ];*/
        //   <PDF isDesktop={this.props.isDesktop} file={this.state.fileURL} fileURLNoName={this.state.fileURL} />
        const { classes, rows } = this.props;
        return (
            <div className={classes.root}>
                <Table className={classes.table}>
                    <TableHead>
                    <TableRow style={{height: 16}}>
                        <TableCell className={classes.header}></TableCell>
                        <TableCell className={classes.header} align="left"></TableCell>
                        <TableCell className={classes.header} align="left">{this.context.t('File')}</TableCell>
                    </TableRow>
                    </TableHead>
                    <TableBody>
                        {
                            rows.map((row, index) => (
                                <TableRow key={index} hover style={{height: 16}}>
                                    <TableCell className={classes.row} component="th" scope="row">
                                        {index+1}
                                    </TableCell>
                                    <TableCell className={classes.row} align="left">
                                        {row.doc_name}
                                    </TableCell>
                                    <TableCell className={classes.row} align="left">

                                        {(''+row.filename).includes('pdf') &&
                                        <span onClick={() => this.handleClickOpen('https://www.hkarbsoc.org.hk:9000/getUploadedDoc/?id=' + row.filename)}
                                            className={classes.link}>
                                            <a>{row.filename}</a>
                                        </span>}

                                        {(!(''+row.filename).includes('pdf')) &&
                                        <a  target='_blank'
                                            href={'https://www.hkarbsoc.org.hk:9000/getUploadedDoc/?id=' + row.filename}
                                            className={classes.link}
                                        >
                                            {row.filename}
                                        </a>}
                                    </TableCell>
                                </TableRow>
                            ))
                        }
                    </TableBody>
                </Table>
                <Dialog
                    fullScreen
                    maxWidth= 'lg'
                    open={this.state.open}
                    onClose={this.handleClose}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                    >
                    <Button 
                        onClick={() => this.handleClose()} 
                        color="primary" 
                        style={{ fontSize: 12 }}
                        autoFocus>
                        {this.context.t('Close')}
                    </Button>
                    <PDFViewer isDesktop={this.props.isDesktop} file={this.state.fileUrl} fileURLNoName={this.state.fileUrl} />
                    
                    
                </Dialog>
            </div>
        );
    }
}

UploadedDoc.contextTypes = {
    t: PropTypes.func
  }

export default withStyles(styles)(UploadedDoc);